<template>
  <div class="containerTable">
    <vxe-table
      ref="xTable"
      border
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      align="center"
      :loading="loading"
      :data="tableData"
      export-config
    >
      <vxe-table-column field="orderSplitNum" title="分单号" min-width="240" sortable />
      <vxe-table-column field="status" title="ETC状态" :formatter="({ cellValue }) => formatterOptions(cellValue, 'status')" min-width="130" sortable />
      <vxe-table-column field="startTime" title="开始时间" min-width="400" sortable />
      <vxe-table-column field="endTime" title="结束时间" min-width="250" sortable />
    </vxe-table>
  </div>
</template>

<script>
import { selectAllSplitOrder } from "@/api/etc";

export default {
  name: "EtcDistanceDetails",
  data() {
    return {
      message: "",
      code: "",
      loading: false,
      tableData: [],
      tuteship: false,
      startTimeRange: "",
      endTimeRange: "",
      modelInvoice: false,
      copy: false,
      listQuery: {
        isHisTory: "0",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: ""
      },
	    Pagingconf: [],
      // 状态 0，未开始、1一开始 ，2已结束，3开票 4过期（异常）
      statusOptions: [
        { value: 0, label: "未开始" },
        { value: 1, label: "已开始" },
        { value: 2, label: "已结束" },
        { value: 3, label: "已开票" },
        { value: 4, label: "已过期" },
      ],
    };
  },
  created() {
  },
  methods: {
    findInfo(code){
      this.code = code
      this.findList()
    },
    async findList() {
      this.loading = true;
      let response = await selectAllSplitOrder({code:this.code})
      this.loading = false;
      this.tableData = response.data;
    },
    // 翻译
    formatterOptions(cellValue, prefix) {
      const item = this[`${prefix}Options`].find(
        (item) => item.value === cellValue
      )
      return item ? item.label : ''
    },
  }
};
</script>

<style scoped>
</style>
